import React from 'react';

const ThemeContext = React.createContext<unknown>(undefined);

export default ThemeContext;
